module.exports = __webpack_public_path__ + "images/help_v2/avatars/gaoyu-bda680c0bfbc31addba509f39ae3bc72.png";